import axios from 'axios'

const setCsrfToken = () => {
  const csrf = document.querySelectorAll('meta[name="csrf-token"]')[0].getAttribute('content')

  axios.defaults.headers.common['X-CSRF-Token'] = csrf
}

export const archiveSelected = (selectedIds, cb) => {
  setCsrfToken(axios)
  axios.defaults.headers.common['Accept'] = 'application/json'

  axios.post('feedbacks/archive', {id: selectedIds})
    .then(cb)
    .catch(e => { console.log('error', e)})
}

export const fetchFeedbacks = cb => {
  axios.get('feedbacks.json')
    .then(cb)
    .catch(e => {console.log('error', e)})
}

export const exportFeedbacks = cb => {
  axios.get('feedbacks/export.json')
    .then(cb)
    .catch(e => {console.log('error', e)})
}

export const submitFeedback = (data, cb) => {
  setCsrfToken(axios)
  axios.defaults.headers.common['Accept'] = 'application/json'

  axios.post('feedbacks', data)
    .then(cb)
    .catch(e => {console.log('error', e)})
}

export const fetchRasterPixelCategory = ({layerSlug, lngLat}, cb) => {
  axios.get(`pixel-category/${layerSlug}.json?lat=${lngLat.lat}&long=${lngLat.lng}`)
    .then(cb)
    .catch(e => console.log('error', e))
}